/**
 * Migration: cleanup AI-planner localStorage/sessionStorage tồn đọng từ
 * feature đã bị remove (Jira PF-21 ?).
 *
 * Chạy 1 lần mỗi browser (idempotent qua marker key). Sau ~3-6 tháng khi
 * đa số DAU đã pass migration, có thể xoá: helper này + call site trong
 * `AddressCookieSync` — không touch logic khác.
 */
const MARKER_KEY = 'ahafood.ai-planner.cleaned-v1';

const STORAGE_KEYS = {
  local: [
    'ahafood.ai-planner', // Zustand persist key (AI_PLANNER_STORE_NAME)
  ],
  session: [
    'ahafood.ai-planner.banner-dismissed', // BANNER_DISMISS_KEY
  ],
};

export function cleanupAiPlannerStorage(): void {
  if (typeof window === 'undefined') return;

  try {
    if (localStorage.getItem(MARKER_KEY) === 'true') return;

    for (const key of STORAGE_KEYS.local) {
      localStorage.removeItem(key);
    }
    for (const key of STORAGE_KEYS.session) {
      sessionStorage.removeItem(key);
    }

    localStorage.setItem(MARKER_KEY, 'true');
  } catch {
    // Storage quota / privacy mode — skip, retry next load
  }
}
